module.exports = __webpack_public_path__ + "static/media/Barcellos.54677b2c.png";